module.exports = __webpack_public_path__ + "static/media/logo.d55ecc8b.svg";